import { api } from './client'
import type { ActionPriority } from './contactOverview'

/**
 * F-076 (TASK-0330): client delle regole di cross-selling (`CrossSellRulesController`,
 * `/api/cross-sell-rules`, solo Admin) e del report di penetrazione (`ProductPenetrationController`,
 * `GET /api/reports/product-penetration`, solo ruoli Manager). Nessun importo.
 */

export interface CrossSellRule {
  id: number
  name: string
  ifHasDepartmentId: number | null
  ifHasProductId: number | null
  ifLacksDepartmentId: number | null
  ifLacksProductId: number | null
  customerSegment: string | null
  suggestionLabel: string
  priority: ActionPriority
  isActive: boolean
  createdBy: number | null
  createdAt: string
  updatedAt: string | null
}

/** Corpo di creazione/modifica. Serve almeno una condizione "non possiede" (settore o prodotto). */
export interface CrossSellRuleInput {
  name: string
  ifHasDepartmentId?: number | null
  ifHasProductId?: number | null
  ifLacksDepartmentId?: number | null
  ifLacksProductId?: number | null
  customerSegment?: string | null
  suggestionLabel: string
  priority: ActionPriority
  isActive: boolean
}

export interface PenetrationDepartment {
  departmentId: number
  name: string
  clients: number
  /** Frazione 0..1; null con portafoglio vuoto (mai "0%"). */
  share: number | null
}

export interface PenetrationProduct {
  productId: number
  name: string
  clients: number
  share: number | null
}

export interface PenetrationBucket {
  label: string
  clients: number
  share: number | null
}

export interface ProductPenetration {
  perimeter: string
  totalClients: number
  departments: PenetrationDepartment[]
  products: PenetrationProduct[]
  bySectorCount: PenetrationBucket[]
  openSuggestions: {
    total: number
    byPriority: { alta: number; media: number; bassa: number }
    byRule: { ruleId: number; name: string; priority: ActionPriority; label: string; clients: number }[]
  }
  notes: string[]
}

export const crossSellApi = {
  list: () => api<CrossSellRule[]>('/api/cross-sell-rules'),
  create: (input: CrossSellRuleInput) =>
    api<CrossSellRule>('/api/cross-sell-rules', { method: 'POST', body: JSON.stringify(input) }),
  update: (id: number, input: CrossSellRuleInput) =>
    api<CrossSellRule>(`/api/cross-sell-rules/${id}`, { method: 'PUT', body: JSON.stringify(input) }),
  remove: (id: number) => api<void>(`/api/cross-sell-rules/${id}`, { method: 'DELETE' }),
  penetration: () => api<ProductPenetration>('/api/reports/product-penetration'),
}
